import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import HeaderMenu from "./header-menu";
import KhatabaIcon from "./KhatabaIcon";
import HeaderUtilities from "./HeaderUtilities";
import HeaderProfile from "./HeaderProfile";
import getDashBoardStore from "../../stores/dashboard-store";
import Et3Text from "../../core/et3-text";
import i18n from "../../constants/i18n";
import { SIDE_BAR_WIDTH } from "../side-bar/side-bar-constants";
import {
  HEADER_ACCENT_GRADIENT,
  HEADER_ACCENT_HEIGHT,
  HEADER_ALERT_FONT_SIZE,
  HEADER_ALERT_HEIGHT,
  HEADER_HEIGHT,
  HEADER_PADDING_X,
  HEADER_SHADOW,
  HEADER_WIDTH
} from "./header-constants";

const Header = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const isAlert = getDashBoardStore().getIsAlert.get();
  const contentInset = (SIDE_BAR_WIDTH + HEADER_PADDING_X) * unitX;

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 100
      }}
    >
      <KhatabaIcon />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={HEADER_WIDTH}
        height={HEADER_HEIGHT}
        fDirection={"row"}
        color={colors.all.white}
        style={{
          boxSizing: "border-box",
          gap: HEADER_PADDING_X * unitX,
          boxShadow: HEADER_SHADOW,
          paddingLeft: contentInset,
          paddingRight: HEADER_PADDING_X * unitX
        }}
        alignItems="center"
        justifyContent="flex-start"
        onClick={() => {}}
      >
        <HeaderMenu />
        <HeaderUtilities />
        <HeaderProfile />
      </ET3Div>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={HEADER_WIDTH}
        height={HEADER_ACCENT_HEIGHT}
        fDirection={"row"}
        color={colors.all.transparent}
        style={{ backgroundImage: HEADER_ACCENT_GRADIENT }}
        alignItems="center"
        justifyContent="center"
        onClick={() => {}}
      />
      {isAlert ? (
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={false}
          width={HEADER_WIDTH}
          height={HEADER_ALERT_HEIGHT}
          fDirection={"row"}
          color={colors.all.red}
          style={{}}
          alignItems="center"
          justifyContent="center"
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"BOLD"}
            fontSize={HEADER_ALERT_FONT_SIZE}
            text={i18n.get("ALERT")}
            isSpan={false}
            color={colors.all.white}
            style={{ margin: 0 }}
          />
        </ET3Div>
      ) : null}
    </header>
  );
});
export default Header;
